<template>
  <div class="container sv027">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>指定口座へのお振込みによるご返済</HeadingOne>

    <ListGroup>
      <ListItem
        >当社指定のご返済専用口座へのお振込みによるご返済が可能です。</ListItem
      >
      <ListItem
        >口座番号はお客さまごとに異なるため、会員さま専用サイトにログインのうえご確認ください。</ListItem
      >
    </ListGroup>
    <ListGroup class="-note">
      <ListItem class="-note"
        >振込手数料はお客さまのご負担になります。</ListItem
      >
    </ListGroup>

    <section>
      <StepList type="sv" class="_mb-md-60 _mb-sm-20 -green">
        <HeadingTwo>指定口座へのお振込みによるご返済方法</HeadingTwo>
        <StepItem
          number="1"
          title="会員さま専用サイトへログイン"
          src="sv/sv027/img01.jpg"
          src-sp="sv/sv027/sp/img01.jpg"
        >
          <p>会員さま専用サイトへログインします。</p>
          <BtnMain class="-normal" router-name="ce001">
            会員さま専用サイトトップへ
          </BtnMain>
        </StepItem>
        <StepItem
          number="2"
          title="「指定口座へのお振込み」を選択"
          src="sv/sv027/img02.jpg"
          src-sp="sv/sv027/sp/img02.jpg"
          class="-last"
        >
          <p>「ご返済」メニューより「指定口座へのお振込み」をご選択ください</p>
        </StepItem>
        <StepFooter>
          <template #heading>指定口座へのお振込み手続き</template>
          <template #text>
            <p class="_mt-15">
              各種金融機関より、ご返済専用口座へお振込み手続きをお願いいたします。
            </p>
            <p>お振込手数料はお客さまのご負担となります。</p>
          </template>
        </StepFooter>
      </StepList>
    </section>

    <section class="_mb-md-120 _mb-sm-60">
      <HeadingTwo>ご返済時期について</HeadingTwo>
      <p class="-bold">
        毎月のご返済日（26日＊）の20日前より、当月のご返済が可能です。
      </p>
      <div class="_mb-md-60 _mb-sm-30">
        <small>* 金融機関休業日の場合は、翌営業日となります。</small>
      </div>

      <div class="_textcenter _mb-10">
        <img
          src="@/assets/images/sv/sv027/img05.png"
          class="img-fluid -spnone"
          alt=""
        />
        <img
          src="@/assets/images/sv/sv027/sp/img05.png"
          class="img-fluid -pcnone"
          alt=""
        />
      </div>

      <ListGroup class="-note">
        <ListItem class="-note"
          >当該期間にご返済いただいた場合、次回の期日返済は次月の26日となります。</ListItem
        >
      </ListGroup>
    </section>

    <CvBox class="_mb-md-120 _mb-sm-60" />

    <ContactBox class="_mb-md-120 _mb-sm-60" />
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
// import BtngroupSingle from '@/components/button/BtngroupSingle';
import BtnMain from "@/components/button/BtnMain";
import ContactBox from "@/components/box/ContactBox";
import CvBox from "@/components/box/CvBox";
// import CardBox from '@/components/card/CardBox';
// import CardHeader from '@/components/card/CardHeader';
// import CardBody from '@/components/card/CardBody';
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
// import CardLink from '@/components/card/CardLink';
// import ChartBox from '@/components/charts/ChartBox';
// import ChartHeader from '@/components/charts/ChartHeader';
// import ChartBody from '@/components/charts/ChartBody';
// import ChartRow from '@/components/charts/ChartRow';
// import ChartData from '@/components/charts/ChartData';
import StepList from "@/components/steps/StepList";
import StepItem from "@/components/steps/StepItem";
import StepFooter from "@/components/steps/StepFooter";
// import BtnText from '@/components/button/BtnText';

export default {
  name: "Sv027",
  components: {
    BreadcrumbGroup,
    // BtnText,
    StepFooter,
    StepItem,
    StepList,
    // ChartData,
    // ChartRow,
    // ChartBody,
    // ChartHeader,
    // ChartBox,
    // CardLink,
    ListItem,
    ListGroup,
    // CardBody,
    // CardHeader,
    // CardBox,
    CvBox,
    ContactBox,
    BtnMain,
    // BtngroupSingle,
    HeadingOne,
    HeadingTwo,
  },
  setup() {
    setMeta({
      title: "指定口座へのお振込み｜ご返済方法",
      description:
        "ご返済専用口座へのお振込みによるご返済方法についてご案内します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,指定口座,お振込み",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "ご返済について",
          routerName: "sv047",
        },
        {
          text: "指定口座へのお振込み",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
